<div class="queue-editor-dialog-wrapper">
    <form [formGroup]="queueForm" class="queue-editor-form">
        <!-- Name -->
        <div class="field">
            <label for="name" class="block mb-2">Queue Name: </label>
            <input
                id="name"
                type="text"
                pInputText
                formControlName="name"
                maxlength="1000"
                class="w-full"
                placeholder="Write a queue name"
            />
        </div>

        <div class="field">
          <label for="priority" class="block mb-2">Priority:</label>
          <input
              id="priority"
              type="number"
              pInputText
              formControlName="priority"
              class="w-full"
              [max]="1000000"
              placeholder="Enter a priority for the queue"
            />
        </div>

        <!-- Description -->
        <div class="field">
            <label for="description" class="block mb-2">Description: </label>
            <textarea
                id="description"
                pInputTextarea
                maxlength="1000"
                formControlName="description"
                rows="4"
                class="w-full"
                placeholder="Write a description"
            ></textarea>
        </div>

        <!-- Assigned Roles -->
        <div class="field">
            <label for="roles" class="block mb-2">Roles with Access: </label>
            <p-multiSelect
                [options]="roles"
                inputId="roles"
                formControlName="assignedToRoles"
                optionLabel="name"
                optionValue="id"
                display="chip"
                placeholder="Select roles"
                class="w-full"
                appendTo="body"
                [autoZIndex]="true"
                [baseZIndex]="12000"
            >
                >
            </p-multiSelect>
        </div>

        <div class="field">
            <label for="queue-builder" class="block mb-2">Add Queue Conditions:</label>
            <input type="hidden" formControlName="filters" />
            <cv-json-filter-builder
                *ngIf="queueOptionSets.length"
                [existingLogic]="getCurrentQueueLogic()"
                (logicChange)="saveQueueLogic($event)"
                [optionSets]="queueOptionSets"
            ></cv-json-filter-builder>
        </div>
    </form>
    <div class="queue-editor-dialog-footer">
        <button
            pButton
            class="cv-queues-button p-button-secondary"
            type="button"
            (click)="cancel()"
            label="Cancel"
        ></button>
        <button
            pButton
            class="cv-queues-button p-button-primary"
            type="button"
            [disabled]="queueForm.invalid"
            (click)="save()"
            label="Save"
        ></button>
    </div>
</div>
